import { c as _c } from "react/compiler-runtime";
const SkeletonLine = t0 => {
  const $ = _c(2);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `bg-gray-200 rounded animate-pulse ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <div className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
};
const SkeletonCard = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-white border border-gray-200 rounded-lg p-6"><SkeletonLine className="h-5 w-24 mb-6" /><SkeletonLine className="h-4 w-32 mb-3" /><SkeletonLine className="h-4 w-48 mb-3" /><SkeletonLine className="h-4 w-40 mb-6" /><SkeletonLine className="h-9 w-32 rounded" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const AccountLoadingSkeleton = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden lg:block w-48 flex-shrink-0 mr-12"><SkeletonLine className="h-6 w-32 mb-4" /><SkeletonLine className="h-4 w-28 mb-3" /><SkeletonLine className="h-4 w-24 mb-3" /><SkeletonLine className="h-4 w-32 mb-3" /><SkeletonLine className="h-4 w-20 mb-3" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-between mb-5"><SkeletonLine className="h-8 w-40" /><SkeletonLine className="h-4 w-32" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-6 order-1"><SkeletonCard /><SkeletonCard /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-6 order-2 lg:order-3"><div className="bg-white border border-gray-200 rounded-lg p-6"><SkeletonLine className="h-5 w-28 mb-6" /><SkeletonLine className="h-4 w-32 mb-3" /><SkeletonLine className="h-4 w-48 mb-3" /><SkeletonLine className="h-4 w-44 mb-3" /><SkeletonLine className="h-4 w-36 mb-6" /><SkeletonLine className="h-5 w-36 mb-4 mt-8" /><SkeletonLine className="h-4 w-40 mb-3" /><SkeletonLine className="h-4 w-48 mb-3" /><SkeletonLine className="h-4 w-44" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative flex flex-col lg:flex-row items-start site-padding mb-16 mt-4">{t0}<div className="mt-0 w-full">{t1}<div className="grid grid-cols-1 md:grid-cols-2 3xl:grid-cols-3 gap-6 w-full">{t2}{t3}<div className="space-y-6 order-3 lg:order-2"><SkeletonCard /><SkeletonCard /></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default AccountLoadingSkeleton;